@if (formBuilt) {
  <div class="grid-x grid-margin-x">
    <div class="cell small-6 text-align-right">
      <button class="button" (click)="saveChanges()" [disabled]="disableSave">Save</button>
    </div>
    <div class="cell small-6 text-align-left">
      <button class="button" (click)="cancel()">Cancel</button>
    </div>
  </div>
  <form [formGroup]="formGroup">
    <div class="grid-x grid-margin-x">
      <div class="cell small-12">
        <label class="bold" [ngClass]="{ 'red' : formGroup?.get('documentGroup')?.invalid }" for="documentGroup">Document Group*:</label>
        <text-loader [run]="documentGroups == null" [text]="'Loading Document Groups'" [tickType]="'.'" [interval]="2000"></text-loader>
        @if (documentGroups?.length > 0) {
          <select id="documentGroup" class="margin-bottom" formControlName="documentGroup" (change)="documentGroupChanged($event)">
            @for (g of documentGroups; track g) {
              <option [ngValue]="g.name">{{g.name}}</option>
            }
          </select>
        }
      </div>
      <div class="cell small-12">
        <label class="bold" [ngClass]="{ 'red': formGroup?.get('documentType')?.invalid }" for="documentType">Document Type*:</label>
        <text-loader [run]="documentTypes == null" [text]="'Loading Document Types'" [tickType]="'.'" [interval]="2000"></text-loader>
        @if (documentTypes != null) {
          <select id="documentType" class="margin-bottom" formControlName="documentType" (change)="documentTypeChanged($event)">
            @for (t of documentTypes; track t) {
              <option [ngValue]="t.name">{{t.name}}</option>
            }
          </select>
        }
      </div>
    </div>
    <div class="grid-x grid-margin-x">
      <div class="cell small-9 bold text-align-left">
        Available Keywords:
      </div>
      <div class="cell small-3 text-align-left">
        <help-text [helpText]="helpText"></help-text>
      </div>
      @if (keywordsLoaded) {
        <div class="cell small-10">
          <select id="selectedKeyword" formControlName="selectedKeyword">
            @for (k of keywordList; track k) {
              <option [ngValue]="k.name">{{k.name}}</option>
            }
          </select>
        </div>
        <div class="cell small-2">
          <button class="button" (click)="addKeyword()" [disabled]="disableAdd">Add</button>
        </div>
      } @else {
        <div class="cell small-12">
          <text-loader [run]="!keywordsLoaded" [text]="'Loading keywords'" [tickType]="'.'" [interval]="2000"></text-loader>
        </div>
      }
    </div>
    <div class="grid-x grid-margin-x" formGroupName="keywords">
      @for (word of selectedKeywords; track word) {
        <div class="cell small-5 keyword-font bold" [ngClass]="{ 'red' : isKeywordInvalid(word) }">
          {{  getKeywordNameDisplay(word.name) }}@if (word.isRequired) {
          <span>*</span>
          }:
        </div>
        <div class="cell small-5">
          <input type="text" [formControlName]="word.name" />
        </div>
        <div class="cell small-2 text-align-left">
          <button class="button" [disabled]="word.isRequired" (click)="removeKeyword(word)">
            <svg-icon icon="icon-trash" class="small white"></svg-icon>
          </button>
        </div>
      }
      <div class="cell small-12 text-align-center">
        <help-text [helpText]="expressionWarning"></help-text>
      </div>
    </div>
  </form>
} @else {
  <text-loader [run]="true" [text]="'Loading'" [tickType]="'.'" [interval]="2000"></text-loader>
}
